"use client"

import * as SelectPrimitive from "@radix-ui/react-select"
import { ChevronDown } from "lucide-react"
import * as React from "react"

import { CheckSolid } from "../../icons/check-solid"
import * as styles from "./select.styled"

const Select = SelectPrimitive.Root

const SelectGroup = SelectPrimitive.Group

const SelectValue = SelectPrimitive.Value

const SelectTrigger = React.forwardRef<
  React.ComponentRef<typeof SelectPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof SelectPrimitive.Trigger> & {
    hasError?: boolean
  }
>(({ className, children, hasError, ...props }, ref) => (
  <SelectPrimitive.Trigger ref={ref} className={styles.trigger(hasError, className)} {...props}>
    {children}
    <SelectPrimitive.Icon asChild>
      <ChevronDown className={styles.triggerIcon(hasError)} />
    </SelectPrimitive.Icon>
  </SelectPrimitive.Trigger>
))
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName

const SelectContent = React.forwardRef<
  React.ComponentRef<typeof SelectPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof SelectPrimitive.Content>
>(({ className, children, position = "popper", ...props }, ref) => (
  <SelectPrimitive.Portal>
    <SelectPrimitive.Content
      ref={ref}
      className={styles.content(position, className)}
      position={position}
      {...props}
    >
      <SelectPrimitive.Viewport className={styles.viewport(position)}>
        {children}
      </SelectPrimitive.Viewport>
    </SelectPrimitive.Content>
  </SelectPrimitive.Portal>
))
SelectContent.displayName = SelectPrimitive.Content.displayName

const SelectItem = React.forwardRef<
  React.ComponentRef<typeof SelectPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof SelectPrimitive.Item>
>(({ className, children, ...props }, ref) => (
  <SelectPrimitive.Item ref={ref} className={styles.item(className)} {...props}>
    <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>

    <span className={styles.indicatorWrapper}>
      <SelectPrimitive.ItemIndicator>
        <CheckSolid className={styles.indicatorIcon} />
      </SelectPrimitive.ItemIndicator>
    </span>
  </SelectPrimitive.Item>
))
SelectItem.displayName = SelectPrimitive.Item.displayName

export { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue }
